exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div i[data-v-09b6972d]{cursor:pointer}.backButton[data-v-09b6972d]{left:10px}.backButton[data-v-09b6972d],.menuButton[data-v-09b6972d]{position:absolute;top:10px;font-size:30px}.menuButton[data-v-09b6972d]{right:10px}.size-30[data-v-09b6972d]{font-size:30px}.activeIcon[data-v-09b6972d]{color:#ffc72c}", ""]);

// exports
